import styled from 'styled-components';

import { FormContent } from '@dreryk/react-components';

type StyledFormSectionProps = {
   dualColumns?: boolean;
};

const StyledFormSection = styled(FormContent)<StyledFormSectionProps>`
   grid-template-columns: ${({ dualColumns }) => (dualColumns ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)')};
   align-items: start;

   & > *[class^='PeselInput'] {
      grid-column: 1;
   }
`;

StyledFormSection.displayName = 'StyledFormSection';

export { StyledFormSection };
